// import { observable, action } from 'mobx'
import { toast } from 'react-toastify'
// import { PRODUCTION } from '../../../config'
import { requestApi } from '../../../request-api'
export class AuthStore {
  // firebase auth service
  auth
  // last submited phone
  phone
  // save login request to be able to confirm it later using SMS code
  loginRequest
  // initialize firebase app and create auth service
  constructor() {
  }

  sendCode = async (phone) => {
    this.phone = phone;

    try {
      const data = await requestApi('/sendOTP/loginUser', {
        method: 'post',
        body: JSON.stringify({
          phone_number: this.phone
        })
      });
      // console.log("otp is", data.otp);
      localStorage.setItem('otp', JSON.stringify(data.otp));
      return data.otp;
    } catch (error) {
      toast.error(error.message);
      return null;
    }
  };

  confirmCode = async (code, otp) => {
    let newotp = localStorage.getItem('otp')

    const userCredential = await requestApi('/login', {
      method: 'post',
      body: JSON.stringify({
        phone_number: this.phone,
        otp: code,
        sendOtp: newotp
      })
    });

    const { token } = userCredential
    const { user } = userCredential

    localStorage.setItem('user', JSON.stringify(user))
    localStorage.setItem('role_id', JSON.stringify(user.role_id))
    localStorage.setItem('user_id', JSON.stringify(user.id))
    localStorage.setItem('name', JSON.stringify(user.name))

    return { token, user }
  }

  exchangeIdToken = (idToken) =>
    requestApi('/auth/exchange', {
      method: 'post',
      body: JSON.stringify({
        idToken,
        source: "admin"
      }),
    })
}
